export default __webpack_public_path__ + "static/media/machine-guns.882d028e.svg";